// This file is automatically generated. Do not edit manually.

import { CatalogPart } from "src/api/generated/erp/db/types/tables/catalogPart";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace CatalogPartQueryApi {
	export async function getPartCategoryCatalogParts(args: { partCategoryId: number }): Promise<Array<CatalogPart>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/configurator/managing/catalogPart/getPartCategoryCatalogParts",
			method: "POST",
			data: {
				partCategoryId: args.partCategoryId,
			},
		});
		return response as Array<CatalogPart>;
	}
}
